import { render, staticRenderFns } from "./content-menu-editor-mobile.vue?vue&type=template&id=32d22e80"
import script from "./content-menu-editor-mobile.vue?vue&type=script&lang=js"
export * from "./content-menu-editor-mobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports